<template>
  <div class="refund-rules">
    <h1 class="refund-rules__main-header">Правила возврата денежных средств</h1>
    <div class="refund-rules__wrapper">
      <h2 class="refund-rules__block-header">
        Пожалуйста, ознакомьтесь с правилами и условиями ВОЗВРАТА АВИАБИЛЕТОВ:
      </h2>
      <h3 class="refund-rules__header">1. ОСНОВНЫЕ ПРАВИЛА ВОЗВРАТА</h3>
      <p class="refund-rules__text">
        1.1. Заявки на возврат обрабатываются в порядке очередности. Срок
        обработки заявки составляет от 4-х до 48-ми часов (в зависимости от
        выбранной формы оплаты).
      </p>
      <p class="refund-rules__text">
        1.2. Плата за услуги Агента при оформлении перевозки возврату не
        подлежит
      </p>
      <p class="refund-rules__text">
        1.3. За оформление Агентом процедуры возврата установлена плата, размеры
        которой указаны в п. 5.7. Оферты.
      </p>
      <p class="refund-rules__text">
        1.4. В случае предоставления скидки на авиабилет, скидка не
        возвращается, размер скидки удерживается из суммы денежных средств,
        подлежащих возврату.
      </p>
      <p class="refund-rules__text">
        1.5. Обращаем ваше внимание на то, что ряд тарифов являются
        невозвратными. Информация об условиях возврата/не возврата тарифа
        публикуется в условиях применения тарифа (УПТ) и, в отдельных случаях,
        указывается в маршрутной-квитанции.
      </p>
      <p class="refund-rules__text">
        1.6. Возврат авиабилета производится только на основании заполненной
        формы установленного образца. Заявки в свободной форме не принимаются.
      </p>
      <h3 class="refund-rules__header">
        2. ВОЗВРАТ СУММ ЗА НЕ ВЫПОЛНЕННУЮ ПЕРЕВОЗКУ
      </h3>
      <p class="refund-rules__text">2.1. Категории возвратов</p>
      <p class="refund-rules__text">
        2.1.1. Вынужденным отказом пассажира от полета, расторжения договора
        воздушной перевозки признается в случае:
      </p>
      <p class="refund-rules__text">
        а) Отмены или задержки рейса, указанного в перевозочном документе
        (билете);
      </p>
      <p class="refund-rules__text">
        б) Изменения авиакомпанией маршрута перевозки;
      </p>
      <p class="refund-rules__text">в) Выполнения рейса не по расписанию;</p>
      <p class="refund-rules__text">
        г) Несостоявшейся отправки пассажира из-за невозможности предоставить
        ему места на рейс и дату, указанные в билете;
      </p>
      <p class="refund-rules__text">
        д) Несостоявшейся перевозки пассажира на воздушном судне, вызванной
        задержкой пассажира в аэропорту из-за продолжительности проведения его
        досмотра, если при досмотре багажа или личном досмотре пассажира не было
        обнаружено запрещенных к перевозке веществ и предметов;
      </p>
      <p class="refund-rules__text">
        е) Не обеспечения перевозчиком стыковки рейсов в случае выполнения
        единой перевозки;
      </p>
      <p class="refund-rules__text">
        ж) Внезапной болезни пассажира либо болезни или смерти члена его семьи,
        совместно следующего с ним на воздушном судне, что подтверждено
        медицинскими документами;
      </p>
      <p class="refund-rules__text">
        з) Не предоставления пассажиру обслуживания по классу, указанному в
        билете.
      </p>
      <p class="refund-rules__text">
        2.1.2. Отказ пассажира от полета, в случаях, не предусмотренных в пункте
        2.1.2 признается добровольным отказом от перевозки.
      </p>
      <p class="refund-rules__text">
        2.1.3. В случае прекращения действия договора воздушной перевозки
        пассажира в связи с добровольным отказом пассажира от части перевозки
        возвращается разница между примененным тарифом и тарифом использованного
        участка маршрута перевозки. Расчет стоимости использованного участка
        маршрута перевозки осуществляется по нормальному тарифу соответствующего
        класса обслуживания перевозчика, выполнившего перевозку,
        действовавшему(им) на дату начала перевозки в день оформления
        авиабилета, если перевозчиком не предусмотрено применение для расчета
        другого тарифа.
      </p>
      <p class="refund-rules__text">
        2.1.4. При осуществлении добровольного возврата денежных сумм
        авиакомпания в соответствии с условиями применения тарифа оставляет за
        собой право установить Сбор за отказ пассажира от полета и Плату за
        процедуру возврата, взимаемые с пассажира.
      </p>
      <p class="refund-rules__text">
        2.2. Возврат денежных средств производится:
      </p>
      <p class="refund-rules__text">
        2.2.1 При оплате авиабилета банковской картой - на счет владельца карты,
        с использованием которой осуществлялась оплата.
      </p>
      <p class="refund-rules__text">
        2.2.2 При оплате авиабилета наличными денежными средствами – в офисе
        продаж пассажиру, указанному в авиабилете.
      </p>
      <p class="refund-rules__text">
        2.2.3 При оплате через платежных агентов (Евросеть, Связной,
        онлайн-банкинг и т.п.) - безналичным платежом на расчетный счет
        пассажира, указанный в заявлении на возврат.
      </p>
      <p class="refund-rules__text">
        Настоящим я подтверждаю, что ознакомился с правилами возврата
        авиабилетов и прошу расторгнуть договор воздушной перевозки на указанных
        выше условиях. Понимаю, что подача заявки на возврат влечет за собой
        полную аннуляцию перевозки. Соглашаюсь оплатить установленные
        авиакомпанией и агентством сборы за возврат.
      </p>
    </div>
    <Button class="refund-rules__btn" label="Назад" @click="back" />
  </div>
</template>

<script>
import { defineComponent, ref } from "vue";
import Button from "primevue/button";
import Ripple from "primevue/ripple";

export default defineComponent({
  name: "RefundRules",
  components: {
    Button,
  },
  setup() {
    const checked = ref(false);
    return {
      checked,
    };
  },
  methods: {
    back() {
      window.history.go(-1);
    },
  },
  directives: {
    ripple: Ripple,
  },
});
</script>

<style lang="scss">
.refund-rules__wrapper {
  background: #ffffff;
  border-radius: 5px;
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
  overflow: hidden;
  padding: 10px;
  margin-top: 20px;
  margin-bottom: 10px;
}
.refund-rules__main-header {
  font-size: 20px;
  margin-left: 20px;
}
.refund-rules__block-header {
  font-size: 18px;
  margin-bottom: 5px;
}
.refund-rules__header {
  font-size: 18px;
  margin-top: 7px;
  margin-bottom: 7px;
}
.refund-rules__text {
  font-size: 16px;
  margin-bottom: 5px;
}

.refund-rules__btn {
  padding: 10px 40px !important;
}
@media screen and (max-width: 767px) {
  .refund-rules__main-header {
    font-size: 18px;
    margin-left: 20px;
  }
  .refund-rules__block-header {
    font-size: 15px;
    margin-bottom: 5px;
  }
  .refund-rules__header {
    font-size: 15px;
    margin-top: 7px;
    margin-bottom: 7px;
  }
  .refund-rules__text {
    font-size: 1rem;
    margin-bottom: 5px;
  }
}
</style>
